import { Check, Languages } from "lucide-react"
import { Button } from "@holigral/shared/ui/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@holigral/shared/ui/components/ui/dropdown-menu"
import { type Locale, SUPPORTED_LOCALES, useT } from "@holigral/shared/i18n"

type Props = {
  current: Locale
  onSelect: (locale: Locale) => void
  /** Trigger button style; defaults to the tertiary. */
  variant?: "ghost" | "outline"
  align?: "start" | "end"
}

/**
 * The language dropdown. Presentational: navigating, persisting a preference
 * or changing the language in place is up to the caller.
 */
export default function LocaleSwitcher({
  current,
  onSelect,
  variant = "ghost",
  align = "end",
}: Props) {
  const { t } = useT("shared")

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button variant={variant} size="sm" aria-label={t("changeLanguage")}>
            <Languages />
            {t(`locales.${current}`)}
          </Button>
        }
      />
      <DropdownMenuContent align={align}>
        {SUPPORTED_LOCALES.map((locale) => (
          <DropdownMenuItem
            key={locale}
            onClick={() => {
              if (locale !== current) {
                onSelect(locale)
              }
            }}
          >
            <Check
              className={locale === current ? "opacity-100" : "opacity-0"}
            />
            {t(`locales.${locale}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
